<template>
  <div>
    <!-- LUX SETUP -->
    <vk-offcanvas-content>
      <vk-offcanvas flipped overlay stuck :show.sync="showSetup">
        <vk-offcanvas-close @click="showSetup = false"></vk-offcanvas-close>
        <lux-setup></lux-setup>
      </vk-offcanvas>
    </vk-offcanvas-content>
    <!-- LUX UPDATE -->
    <vk-offcanvas-content>
      <vk-offcanvas flipped overlay stuck :show.sync="showUpdate">
        <vk-offcanvas-close @click="showUpdate = false"></vk-offcanvas-close>
        <luxdevice-update :LuxUpdate="this.updateParams"></luxdevice-update>
      </vk-offcanvas>
    </vk-offcanvas-content>
    <div>
      <!-- LUX Onboarding -->
      <div
        class="page-content__header-description"
        style="display: flex; width: 89%; margin-left: auto; margin-right: auto;"
      >
        <h2 style="flex: 1; align-items: center;">LUX Onboarding</h2>
        <div
          v-if="usertype != 'customer'"
          style="display: flex; margin-top: 16px;"
        >
          <!-- Create user button -->
          <button
            style="flex: 1;"
            class="btn btn-xl btn-primary create_button"
            @click="showSetup = true"
          >
            + Create User
          </button>
        </div>
      </div>
      <!-- Total Lux power -->
      <div
        style="width: 89%; margin-left: auto; margin-right: auto; margin-top: 24px;"
      >
        <p style="text-align: right; color: orange;">
          Total energy generated: {{ luxTotalEnergy }}kWh
        </p>
      </div>

      <!-- The vue-Table -->
      <div
        v-if="!getLoadingState"
        class="main-container"
        style="width: 90%; margin: auto;"
      >
        <div>
          <h3 class="pagin_style" style="color: #6a707e;">
            Showing
            {{
              paginationInfo.total > 0
                ? `${paginationInfo.first} - ${paginationInfo.last}
        ${paginationInfo.ofText} ${paginationInfo.total} ${
                    paginationInfo.total > 1 ? "Devices" : "Device"
                  }`
                : "no device"
            }}
          </h3>
          <el-input
            style="width: 30%"
            class="el-input el-input--prefix"
            placeholder="Enter Device ID"
            prefix-icon="el-icon-search"
            v-model="searchTerm"
            clearable
          ></el-input>
          <vue-good-table
            :lineNumbers="true"
            :columns="fields"
            :rows="getUsers"
            :search-options="{
              enabled: true,
              searchFn: searchTable,
              externalQuery: searchTerm
            }"
            :pagination-options="{ enabled: true }"
          >
            <template slot="table-row" slot-scope="props">
              <span
                @click="tableRowClicked(props)"
                v-if="props.column.field == 'deviceId'"
              >
                {{ props.row.deviceId ? props.row.deviceId : "----" }}
              </span>

              <span v-if="props.column.field == 'serialNumbers'">
                {{
                  props.row.serialNumbers
                    ? props.row.serialNumbers.join(", ")
                    : "----"
                }}
              </span>

              <span v-if="props.column.field == 'Version'">
                {{ props.row.Version ? props.row.Version : "----" }}
              </span>

              <span v-if="props.column.field == 'BatCap'">
                {{ props.row.batCapacity ? props.row.batCapacity : "----" }}
              </span>

              <span v-if="props.column.field == 'paymentType'">
                {{ props.row.paymentType ? props.row.paymentType : "----" }}
              </span>
              <span v-if="props.column.field == 'actions'">
                <div class="action_style">
                  <a-dropdown :trigger="['click']">
                    <p class="ant-dropdown-link ellipsis_style">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </p>
                    <template slot="overlay">
                      <a-menu>
                        <a-menu-item class="action_update" key="0">
                          <p
                            class="fontawesome_style"
                            @click="
                              updateLux(
                                props.row.deviceId,
                                props.row.serialNumbers,
                                props.row.Version,
                                props.row.paymentType,
                                props.row.MiscData.CID,
                                props.row.MiscData.ExptdChgCyl,
                                props.row.CLoad
                              )
                            "
                          >
                            <i class="fas fa-edit"> </i> Edit
                          </p>
                        </a-menu-item>
                        <a-menu-divider />
                        <a-menu-item class="action_delete" key="1">
                          <p
                            class="fontawesome_style"
                            @click="
                              deleteModal(
                                props.row.deviceId ? props.row.deviceId : '----'
                              )
                            "
                          >
                            <i class="fa fa-trash"> </i> Delete
                          </p>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
              </span>
            </template>

            <template slot="pagination-bottom" slot-scope="props">
              <grey-pagination
                :total="props.total"
                :pageChanged="props.pageChanged"
                :perPageChanged="props.perPageChanged"
                @paginated-info="paginationInfo = $event"
              ></grey-pagination>
            </template>
          </vue-good-table>

          <modal
            width="500px"
            height="auto"
            name="my-first-modal"
            style="border-radius: 30px !important"
            class="first-modal"
          >
            <div class="form">
              <form name="myForm">
                <p class="triangle">
                  <i
                    class="fa fa-exclamation-triangle fa-3x"
                    style="color:red; background-color: pink; border-radius: 50%; width: 45px; height: 47px; margin: 16px;"
                    aria-hidden="true"
                  ></i>
                </p>
                <h4>
                  Are you sure you want to delete this onboarding record?
                </h4>
                <p
                  style="font-weight: 600; color: #6a707e; border: none; text-align: center;"
                >
                  "{{ DeviceID }}"
                </p>

                <div class="row">
                  <button
                    type="submit"
                    class="button-delete"
                    @click="deleteDevice"
                  >
                    Delete
                  </button>
                  <button class="button-cancel" @click="cancel">
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </modal>
        </div>
      </div>

      <div
        style="height: 500px; background-color: white; display: flex; align-items: center; justify-content: center"
        v-if="getLoadingState"
      >
        <p>Loading, please wait...</p>
      </div>
    </div>
  </div>
</template>

<script>
import LuxDeviceUpdate from "./LuxDeviceUpdate.vue";
import LuxSetup from "./LuxSetup.vue";
import moment from "moment";
import {
  Offcanvas,
  OffcanvasClose,
  OffcanvasContent
} from "vuikit/lib/offcanvas";

moment.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

const items = [];
export default {
  name: "ListLuxUsers",
  components: {
    "vk-offcanvas-content": OffcanvasContent,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "luxdevice-update": LuxDeviceUpdate,
    "lux-setup": LuxSetup
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      showUpdate: false,
      showSetup: false,
      paginationInfo: {},
      searchTerm: "",
      luxTotalEnergy: "",
      editOffCanvas: false,
      isLoading: false,
      idSelected: "",
      DeviceID: "",
      updateParams: {
        deviceId: "",
        serialNumber: [],
        paymentType: "",
        version: "",
        cLoad: "",
        CID: "",
        expChargeCycle: ""
      },
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [
        {
          field: "deviceId",
          label: "Device ID",
          sortable: "true"
        },
        {
          field: "serialNumbers",
          label: "Serial Number(s)",
          sortable: "true"
        },
        {
          field: "Version",
          label: "System Version",
          sortable: "true"
        },
        {
          field: "BatCap",
          label: "Battery Capacity",
          sortable: "true"
        },
        {
          field: "paymentType",
          label: "Payment Type",
          sortable: "true"
        },
        {
          field: "actions",
          label: ""
        }
      ],
      getUsers: [],
      currentPage: 1,
      loading: false,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15]
    };
  },
  computed: {
    // ...mapGetters(["getUsers"])
    getLoadingState: {
      get() {
        return this.loading;
      }
    }
  },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    deleteModal(deviceIDdata) {
      this.DeviceID = deviceIDdata;
      this.show();
    },
    cancel() {
      this.hide();
      this.DeviceID = "";
    },
    deleteDevice(e) {
      e.preventDefault();

      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `devices/${this.DeviceID}`;
      LuxHTTP.delete(url, this.DeviceID)
        .then(res => {
          this.showSuccessMsg({ message: "Device Deleted!" });
          this.init();
          this.hide();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    totalEnergy() {
      this.loading = true;
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `/inverters/total-energy-generated`;

      LuxHTTP.get(url)
        .then(response => {
          this.luxTotalEnergy = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
          this.loading = false;
        });
    },
    updateLux(
      deviceId,
      serialNumber,
      version,
      paymentType,
      CID,
      ExptdChgCyl,
      CLoad
    ) {
      (this.updateParams.deviceId = deviceId),
        (this.updateParams.serialNumber = serialNumber),
        (this.updateParams.paymentType = paymentType),
        (this.updateParams.version = version),
        (this.updateParams.cLoad = CLoad);
      this.updateParams.CID = CID;
      this.updateParams.expChargeCycle = ExptdChgCyl;
      this.showUpdate = true;
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    tableRowClicked(params) {
      let { Version, deviceId } = params.row;
      this.$router.push({
        name: "devicePerformanceV3",
        params: {
          deviceId: deviceId,
          version: Version ? Version.toLowerCase() : "v3"
        }
      });
    },
    init() {
      this.loading = true;
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `/devices/`;

      LuxHTTP.get(url)
        .then(response => {
          this.getUsers = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
          this.loading = false;
        });
    }
  },
  async mounted() {
    this.init();
    this.totalEnergy();
  }
};
</script>

<style scoped>
.first-modal {
  border-radius: 12px;
}
.vm--modal {
  border-radius: 18px !important;
}
.triangle {
  width: 15%;
  margin-left: auto;
  margin-right: auto;
}
.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.create_button {
  border-radius: 10px;
  box-shadow: 0px 2px 4px #42659b;
}

.form {
  padding: 50px auto;
  border-radius: 18px;
}

h4 {
  text-align: center;
}
.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  width: 200px;
}
.button-cancel {
  padding: 5px;
  color: #269af1;
  background: white;
  border-color: #269af1;
  width: 200px;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/ListLuxUsers.vue